import type { RouteRecordRaw } from "vue-router";

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: "/error",
    name: "error",
    component: () => import("@/pages/error.vue")
  },
  {
    path: "/error500",
    name: "error-500",
    component: () => import("@/pages/error-500.vue")
  },
  {
    path: "/:catchAll(.*)*",
    name: "not-found",
    component: () => import("@/pages/error-404.vue")
  }
];
